import { useRouter } from 'next/router'
import Link from 'next/link'

export default function ActiveLink({
  href,
  as: asPath = href,
  children,
  shallow = false,
  activeAs = 'span',
  addHrefActive = false,
  ...props
}) {
  const router = useRouter()

  const as = asPath.pathname || asPath
  const isActive = router.asPath.split('?')[0] === as
  const componentProps = isActive ? { active: 'true', as: activeAs, ...props } : { ...props }

  let elements = React.Children.toArray(children)
  if (elements.length > 1) {
    throw new Error('ActiveLink component accepts only one child')
  }
  const component = React.cloneElement(elements[0], componentProps)

  if (isActive && !addHrefActive) {
    return typeof component.type === 'string' ? (
      <span>{component.props.children}</span>
    ) : (
      <>{component}</>
    )
  } else {
    return (
      <Link href={href} as={as} shallow={shallow} passHref>
        {component}
      </Link>
    )
  }
}
